import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'es', // Set Spanish as the default language
    fallbackLng: 'es', // Set Spanish as the fallback language
    debug: process.env.NODE_ENV === 'development',
    
    // Define namespaces (page-specific translation files)
    ns: ['basic', 'advanced', 'native', 'complete', 'upgrade', 'smartupgrade'],
    defaultNS: 'basic',
    
    backend: {
      // Static loading path for compatibility with older versions
      loadPath: '/landing/locales/{{lng}}/landing/{{ns}}.json'
    },
    
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    
    // Add support for nested keys with dot notation
    keySeparator: '.',
    nsSeparator: ':',
  });

export default i18n;